import { Icons, ListItem } from '@silverfort/sf-components';
import { ReportType, ServiceAccountExportOptions } from '../../ServiceAccountsTypes';
import { memo, useMemo } from 'react';

export const ExportMenuContent = ({
    setShouldShowManager,
    exportOptionsData,
    generateExport
}: {
    setShouldShowManager: React.Dispatch<React.SetStateAction<boolean>>;
    exportOptionsData: ServiceAccountExportOptions;
    generateExport: (key: ReportType, isJson: boolean) => Promise<void>;
}) => {
    const shouldReportManageBeDisabled = useMemo(() => {
        const all_available_reports = Object.entries(exportOptionsData).filter(
            ([optionKey, optionVal], outerIndex) =>
                exportOptionsData[optionKey].csvData?.fileName || exportOptionsData[optionKey].jsonData?.fileName
        );
        return all_available_reports.length === 0;
    }, [exportOptionsData]);

    const generateReportItems = useMemo(() => {
        const res: {
            reportType: ReportType;
            title: string;
            fileType: string;
            isSupported: boolean;
            tooltip: string;
        }[] = [];
        Object.entries(exportOptionsData).forEach(([optionKey, optionVal], outerIndex) => {
            if (!optionVal.supportedReportTypes) return;
            Object.entries(optionVal.supportedReportTypes).forEach(([fileType, isSupported], innerIndex) => {
                res.push({
                    reportType: optionKey as ReportType,
                    title: `${optionVal.reportName} (${fileType.toUpperCase()})`,
                    fileType,
                    isSupported,
                    tooltip: optionVal.tooltip || ''
                });
            });
        });
        return res;
    }, [exportOptionsData]);

    const ReportItem = memo(
        ({
            value
        }: {
            value: {
                reportType: ReportType;
                title: string;
                fileType: string;
                isSupported: boolean;
                tooltip: string;
            };
        }) => {
            return (
                <div
                    onClick={() => {
                        generateExport(value.reportType, value.fileType === 'json');
                        setShouldShowManager(true);
                    }}>
                    {value.isSupported && (
                        <ListItem
                            key={value.title}
                            IconLeft={Icons.Refresh}
                            title={value.title}
                            value={value.reportType}
                            tooltipDescription={value.tooltip}
                        />
                    )}
                </div>
            );
        }
    );

    return (
        <div className="max-h-[232px] overflow-y-scroll">
            <ListItem
                disabled={shouldReportManageBeDisabled}
                IconLeft={Icons.Document}
                onClick={() => {
                    setShouldShowManager(true);
                }}
                title="Report Manager"
            />

            {generateReportItems.map((value) => {
                return (
                    <div key={value.title}>
                        <ReportItem value={value} />
                    </div>
                );
            })}
        </div>
    );
};
